// Unmuted-state speaker icon. Ported verbatim from helix-web's
// components/global/icons/CustomIcons/videoCarousel/SoundOn.js — plain white
// fill, no helix-specific tokens involved.
const SoundOn = ({ className }) => (
  <svg
    className={`${className} cursor-pointer`}
    width="35"
    height="32"
    viewBox="0 0 35 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 2.50501C20 0.277759 17.3072 -0.837672 15.7322 0.737245L8.23223 8.23725H5.01509C3.11287 8.23725 1.15176 9.34465 0.582173 11.4123C0.20245 12.7908 0 14.2414 0 15.7372C0 17.2331 0.20245 18.6837 0.582173 20.0622C1.15176 22.1299 3.11287 23.2372 5.01509 23.2372H8.23223L15.7322 30.7373C17.3072 32.3122 20 31.1967 20 28.9695V2.50501Z"
      fill="white"
    />
    <path
      d="M28.4728 4.24665C28.961 3.7585 29.7524 3.7585 30.2406 4.24665C36.5866 10.5927 36.5866 20.8816 30.2406 27.2276C29.7524 27.7158 28.961 27.7158 28.4728 27.2276C27.9847 26.7395 27.9847 25.948 28.4728 25.4599C33.8425 20.0902 33.8425 11.3841 28.4728 6.01442C27.9847 5.52627 27.9847 4.73481 28.4728 4.24665Z"
      fill="white"
    />
    <path
      d="M24.0539 8.66621C24.542 8.17805 25.3335 8.17805 25.8216 8.66621C29.7269 12.5715 29.7269 18.9031 25.8216 22.8083C25.3335 23.2965 24.542 23.2965 24.0539 22.8083C23.5657 22.3202 23.5657 21.5287 24.0539 21.0406C26.9828 18.1116 26.9828 13.3629 24.0539 10.434C23.5657 9.94582 23.5657 9.15437 24.0539 8.66621Z"
      fill="white"
    />
  </svg>
);
export default SoundOn;
